import { writable } from 'svelte/store';

export const CriteriaSelected = writable([]);